import api from "apis";
import {
  DocumentAttachmentFileRequest,
  GetUploadPresignedUrlParams,
} from "apis/data-contracts";
import axios from "axios";
import removeSearchFromUrl from "utils/fileUtils/removeSearchFromUrl";

export interface MapFileToFileRequestProps {
  fileType: GetUploadPresignedUrlParams["fileType"];
  file: File;
  fileHash?: string;
  isOverwrite?: boolean;
  allowedExtensions: string[];
}

export default async function mapFileToFileRequest({
  fileType,
  file,
  fileHash,
  allowedExtensions,
  isOverwrite = false,
}: MapFileToFileRequestProps): Promise<DocumentAttachmentFileRequest> {
  // 첨부 파일 처리
  const { data } = await api.s3.getUploadPresignedUrl({
    fileType,
    fileName: file.name,
    isOverwrite,
    allowedExtensions,
  });

  const attachmentFileUrl = data.result.uploadInfo.presignedUrl;
  const attachmentFileUrlWithoutSearch = removeSearchFromUrl(attachmentFileUrl);

  await axios({
    method: "PUT",
    url: attachmentFileUrl,
    data: file,
    headers: {
      "Content-Type": file.type,
    },
  });

  return {
    fileHash,
    fileName: file.name,
    documentFileUrl: attachmentFileUrlWithoutSearch,
  };
}
